<template>
  <div class="about-page">
    <div class="about-page__content-container">
      <AboutArticle :content="content" :images="metaImages" />
    </div>
  </div>
</template>

<script setup lang="ts">
  import AboutArticle from "@website/components/typography/AboutArticle.vue";

  definePageMeta({
    settings: {
      cover: {
        title: "About Us",
      },
    },
  });

  const { getCurrentPageSettings } = useWebsiteContent();
  const { data: pageSettings, suspense: pageSettingsSuspense } = getCurrentPageSettings();
  await pageSettingsSuspense();

  const content = computed(() => pageSettings.value?.additional?.text ?? "");
  const metaImages = computed(() => pageSettings.value?.additional?.images);
</script>

<style lang="scss">
  .about-page {
    &__content-container {
      padding: 0 32px;
      box-sizing: border-box;

      margin: 0 auto;

      width: 1600px;
      max-width: 100%;
    }
  }
</style>
